import { Alert, Button, Center, Container, Paper, Stack, Text, Title } from '@mantine/core'
import { Link, useSearchParams } from 'react-router-dom'

export function PaymentPage() {
  const [searchParams] = useSearchParams()
  const message = searchParams.get('message')

  return (
    <Container size="sm">
      <Center mih="calc(100vh - 160px)">
        <Paper withBorder radius="lg" p="xl" w="100%">
          <Stack align="center" gap="md">
            <Title order={2} ta="center" c="var(--sat-text)">
              Subscription required
            </Title>
            <Alert color="red" variant="light" w="100%">
              {message || 'Your subscription expired'}
            </Alert>
            <Text ta="center" c="dimmed">
              Please renew your subscription or contact your tutor for assistance.
            </Text>
            <Button component={Link} to="/subscription" color="grapefruit">
              Renew Subscription
            </Button>
            <Button component={Link} to="/dashboard" variant="subtle" color="gray">
              Back to dashboard
            </Button>
          </Stack>
        </Paper>
      </Center>
    </Container>
  )
}
